function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
import { logger, getNumberOfUrlSegments, extractPathForTransaction, isRegExp } from '@sentry/utils';
import { shouldDisableAutoInstrumentation } from './utils/node-utils.js';
/**
 * Express integration
 *
 * Provides an request and error handler for Express framework as well as tracing capabilities
 */

var Express = /*#__PURE__*/function () {
  /**
   * Express App instance
   */

  /**
   * @inheritDoc
   */
  function Express() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Express);

    Express.prototype.__init.call(this);

    this._router = options.router || options.app;
    this._methods = (Array.isArray(options.methods) ? options.methods : []).concat('use');
  }
  /**
   * @inheritDoc
   */


  _createClass(Express, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = Express.id;
    }
  }, {
    key: "setupOnce",
    value: function setupOnce(_, getCurrentHub) {
      if (!this._router) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('ExpressIntegration is missing an Express instance');
        return;
      }

      if (shouldDisableAutoInstrumentation(getCurrentHub)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('Express Integration is skipped because of instrumenter configuration.');
        return;
      }

      instrumentMiddlewares(this._router, this._methods);
      instrumentRouter(this._router);
    }
  }], [{
    key: "__initStatic",
    value:
    /**
     * @inheritDoc
     */
    function __initStatic() {
      this.id = 'Express';
    }
  }]);

  return Express;
}();

Express.__initStatic();
/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 *
 * They all internally delegate to the `router[method]` of the given application instance.
 */
// eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any


function wrap(fn, method) {
  var arity = fn.length;

  switch (arity) {
    case 2:
      {
        return function (req, res) {
          var transaction = res.__sentry_transaction;

          if (transaction) {
            var span = transaction.startChild({
              description: fn.name,
              op: "middleware.express.".concat(method)
            });
            res.once('finish', function () {
              span.finish();
            });
          }

          return fn.call(this, req, res);
        };
      }

    case 3:
      {
        return function (req, res, next) {
          var transaction = res.__sentry_transaction;

          var span = _optionalChain([transaction, 'optionalAccess', function (_2) {
            return _2.startChild;
          }, 'call', function (_3) {
            return _3({
              description: fn.name,
              op: "middleware.express.".concat(method)
            });
          }]);

          fn.call(this, req, res, function () {
            _optionalChain([span, 'optionalAccess', function (_4) {
              return _4.finish;
            }, 'call', function (_5) {
              return _5();
            }]);

            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            next.call.apply(next, [this].concat(args));
          });
        };
      }

    case 4:
      {
        return function (err, req, res, next) {
          var transaction = res.__sentry_transaction;

          var span = _optionalChain([transaction, 'optionalAccess', function (_6) {
            return _6.startChild;
          }, 'call', function (_7) {
            return _7({
              description: fn.name,
              op: "middleware.express.".concat(method)
            });
          }]);

          fn.call(this, err, req, res, function () {
            _optionalChain([span, 'optionalAccess', function (_8) {
              return _8.finish;
            }, 'call', function (_9) {
              return _9();
            }]);

            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            next.call.apply(next, [this].concat(args));
          });
        };
      }

    default:
      {
        throw new Error("Express middleware takes 2-4 arguments. Got: ".concat(arity));
      }
  }
}
/**
 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */


function wrapMiddlewareArgs(args, method) {
  return args.map(function (arg) {
    if (typeof arg === 'function') {
      return wrap(arg, method);
    }

    if (Array.isArray(arg)) {
      return arg.map(function (a) {
        if (typeof a === 'function') {
          return wrap(a, method);
        }

        return a;
      });
    }

    return arg;
  });
}
/**
 * Patches original router to utilize our tracing functionality
 */


function patchMiddleware(router, method) {
  var originalCallback = router[method];

  router[method] = function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return originalCallback.call.apply(originalCallback, [this].concat(_toConsumableArray(wrapMiddlewareArgs(args, method))));
  };

  return router;
}
/**
 * Patches original router methods
 */


function instrumentMiddlewares(router) {
  var methods = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  methods.forEach(function (method) {
    return patchMiddleware(router, method);
  });
}
/**
 * Patches the prototype of Express.Router to accumulate the resolved route
 * if a layer instance's `match` function was called and it returned a successful match.
 *
 * @see https://github.com/expressjs/express/blob/master/lib/router/index.js
 *
 * @param appOrRouter the router instance which can either be an app (i.e. top-level) or a (nested) router.
 */


function instrumentRouter(appOrRouter) {
  // This is how we can distinguish between app and routers
  var isApp = ('settings' in appOrRouter); // In case the app's top-level router hasn't been initialized yet, we have to do it now

  if (isApp && appOrRouter._router === undefined && appOrRouter.lazyrouter) {
    appOrRouter.lazyrouter();
  }

  var router = isApp ? appOrRouter._router : appOrRouter;

  if (!router) {
    /*
    If we end up here, this means likely that this integration is used with Express 3 or Express 5.
    For now, we don't support these versions (3 is very old and 5 is still in beta). To support Express 5,
    we'd need to make more changes to the routing instrumentation because the router is no longer part of
    the Express core package but maintained in its own package. The new router has different function
    signatures and works slightly differently, demanding more changes than just taking the router from
    `app.router` instead of `app._router`.
    @see https://github.com/pillarjs/router
     TODO: Proper Express 5 support
    */
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.debug('Cannot instrument router for URL Parameterization (did not find a valid router).');
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.debug('Routing instrumentation is currently only supported in Express 4.');
    return;
  }

  var routerProto = Object.getPrototypeOf(router);
  var originalProcessParams = routerProto.process_params;

  routerProto.process_params = function process_params(layer, called, req, res, done) {
    // Base case: We're in the first part of the URL (thus we start with the root '/')
    if (!req._reconstructedRoute) {
      req._reconstructedRoute = '';
    } // If the layer's partial route has params, is a regex or an array, the route is stored in layer.route.


    var _getLayerRoutePathInf = getLayerRoutePathInfo(layer),
        layerRoutePath = _getLayerRoutePathInf.layerRoutePath,
        isRegex = _getLayerRoutePathInf.isRegex,
        isArray = _getLayerRoutePathInf.isArray,
        numExtraSegments = _getLayerRoutePathInf.numExtraSegments;

    if (layerRoutePath || isRegex || isArray) {
      req._hasParameters = true;
    } // Otherwise, the hardcoded path (i.e. a partial route without params) is stored in layer.path


    var partialRoute = layerRoutePath || layer.path || ''; // Normalize the partial route so that it doesn't contain leading or trailing slashes
    // and exclude empty or '*' wildcard routes.
    // The exclusion of '*' routes is our best effort to not "pollute" the transaction name
    // with interim handlers (e.g. ones that check authentication or do other middleware stuff).
    // We want to end up with the parameterized URL of the incoming request without any extraneous path segments.

    var finalPartialRoute = partialRoute.split('/').filter(function (segment) {
      return segment.length > 0 && (isRegex || isArray || !segment.includes('*'));
    }).join('/'); // If we found a valid partial URL, we append it to the reconstructed route

    if (finalPartialRoute && finalPartialRoute.length > 0) {
      // If the partial route is from a regex route, we append a '/' to close the regex
      req._reconstructedRoute += "/".concat(finalPartialRoute).concat(isRegex ? '/' : '');
    } // Now we check if we are in the "last" part of the route. We determine this by comparing the
    // number of URL segments from the original URL to that of our reconstructed parameterized URL.
    // If we've reached our final destination, we update the transaction name.


    var urlLength = getNumberOfUrlSegments(req.originalUrl || '') + numExtraSegments;
    var routeLength = getNumberOfUrlSegments(req._reconstructedRoute);

    if (urlLength === routeLength) {
      if (!req._hasParameters) {
        if (req._reconstructedRoute !== req.originalUrl) {
          req._reconstructedRoute = req.originalUrl;
        }
      }

      var transaction = res.__sentry_transaction;

      if (transaction && transaction.metadata.source !== 'custom') {
        // If the request URL is '/' or empty, the reconstructed route will be empty.
        // Therefore, we fall back to setting the final route to '/' in this case.
        var finalRoute = req._reconstructedRoute || '/';
        transaction.setName.apply(transaction, _toConsumableArray(extractPathForTransaction(req, {
          path: true,
          method: true,
          customRoute: finalRoute
        })));
      }
    }

    return originalProcessParams.call(this, layer, called, req, res, done);
  };
}
/**
 * Extracts and stringifies the layer's route which can either be a string with parameters (`users/:id`),
 * a RegEx (`/test/`) or an array of strings and regexes (`['/path1', /\/path[2-5]/, /path/:id]`). Additionally
 * returns extra information about the route, such as if the route is defined as regex or as an array.
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns an object containing the stringified route, a flag determining if the route was a regex
 *          and the number of extra segments to the matched path that are additionally in the route,
 *          if the route was an array (defaults to 0).
 */


function getLayerRoutePathInfo(layer) {
  var lrp = _optionalChain([layer, 'access', function (_10) {
    return _10.route;
  }, 'optionalAccess', function (_11) {
    return _11.path;
  }]);

  var isRegex = isRegExp(lrp);
  var isArray = Array.isArray(lrp);

  if (!lrp) {
    return {
      isRegex: isRegex,
      isArray: isArray,
      numExtraSegments: 0
    };
  }

  var numExtraSegments = isArray ? Math.max(getNumberOfArrayUrlSegments(lrp) - getNumberOfUrlSegments(layer.path || ''), 0) : 0;
  var layerRoutePath = getLayerRoutePathString(isArray, lrp);
  return {
    layerRoutePath: layerRoutePath,
    isRegex: isRegex,
    isArray: isArray,
    numExtraSegments: numExtraSegments
  };
}
/**
 * Returns the number of URL segments in an array of routes
 *
 * Example: ['/api/test', /\/api\/post[0-9]/, '/users/:id/details`] -> 7
 */


function getNumberOfArrayUrlSegments(routesArray) {
  return routesArray.reduce(function (accNumSegments, currentRoute) {
    // array members can be a RegEx -> convert them toString
    return accNumSegments + getNumberOfUrlSegments(currentRoute.toString());
  }, 0);
}
/**
 * Extracts and returns the stringified version of the layers route path
 * Handles route arrays (by joining the paths together) as well as RegExp and normal
 * string values (in the latter case the toString conversion is technically unnecessary but
 * it doesn't hurt us either).
 */


function getLayerRoutePathString(isArray, lrp) {
  if (isArray) {
    return lrp.map(function (r) {
      return r.toString();
    }).join(',');
  }

  return lrp && lrp.toString();
}

export { Express };